// Authentication
export const authenticationEndpoints = {
  getLoginDataBySubDomain: (url) => `/Company/GetLoginDataBySubDomain/${url}`,
  validateToken: () => '/auth/validate',
  login: () => '/auth/login',
};

// Dashboard
export const dashboardEndpoints = {
  getChatCategories: (startDate, endDate) =>
    `/Dashboard2/GetChatCategories/${startDate}/${endDate}`,
  getConversationsPerDay: (startDate, endDate) =>
    `/Dashboard2/GetConversationsPerDay/${startDate}/${endDate}`,
  getDashboardNumbers: (startDate, endDate) =>
    `/Dashboard2/GetDashboardNumbers/${startDate}/${endDate}`,
  getAverageDaySessions: (startDate, endDate) =>
    `/Dashboard2/GetAverageSessionsPerDayOfWeek/${startDate}/${endDate}`,
  getAverageHoursSessions: (startDate, endDate) =>
    `/Dashboard2/GetAverageSessionsPerHourOfDay/${startDate}/${endDate}`,
  getUnansweredQuestionsV1: (startDate, endDate) =>
    `/Dashboard2/GetUnansweredQuestionsCount/${startDate}/${endDate}`,
  getUnansweredQuestionsCategories: (startDate, endDate) =>
    `/Dashboard2/GetUnansweredQuestionsPerCategory/${startDate}/${endDate}`,
  getSatisfactionRate: (startDate, endDate) =>
    `/Dashboard2/GetChatSatisfactionDataByCompany/${startDate}/${endDate}`,

  // new dashboard
  GetMessagesConsumedByBot: (startDate, endDate, botId) =>
    `/Dashboard2/GetMessagesConsumedByBot/${startDate}/${endDate}?botId=${botId}`,
  GetUserActivityPerDayHourly: (startDate, endDate, botId, botType) =>
    `/Dashboard2/GetUserActivityPerDayHourly/${startDate}/${endDate}?botId=${botId}&chatSource=${botType}`,
  GetChatSatisfactionDataByCompany: (startDate, endDate, botId) =>
    `/Dashboard2/GetChatSatisfactionDataByCompany/${startDate}/${endDate}?botId=${botId}`,
  GetUserTraffic: (startDate, endDate, botId) =>
    `/Dashboard2/GetUserTraffic/${startDate}/${endDate}?botId=${botId}`,
  GetChatCategories: (startDate, endDate, botId, botType, country) =>
    `/Dashboard2/GetChatCategories/${startDate}/${endDate}?botId=${botId}&chatSource=${botType}&country=${country}`,
  GetChatCategoriesByTopic: (startDate, endDate, botId, botType, country) => {
    const base = `/dashboard2/getChatCategoriesByTopic/${startDate}/${endDate}?botId=${botId}&chatSource=${botType}`;

    return country === 'ALL' ? base : `${base}&country=${country}`;
  },
  GetQuestionsByTopic: (startDate, endDate, botId, botType, country) =>
    `/dashboard2/getQuestionsByTopic/${startDate}/${endDate}?botId=${botId}&chatSource=${botType}&country=${country}`,
  getUnansweredQuestions: (startDate, endDate, pageSize, pageNumber, botId) =>
    `/Dashboard2/getUnansweredQuestionsCount/${startDate}/${endDate}?pageSize=${pageSize}&pageNumber=${pageNumber}&botId=${botId}`,
  getCountryData: (startDate, endDate, botId) =>
    `/Dashboard2/GetCountryData/${startDate}/${endDate}?botId=${botId}`,
  getMessagesLeft: () => `/Dashboard2/GetMessagesLeft`,
  getMessagesPerConversation: (startDate, endDate) =>
    `/Dashboard2/GetMessagesPerConversation/${startDate}/${endDate}`,
  getEngagementRate: (startDate, endDate) =>
    `/Dashboard2/GetEngagementRate/${startDate}/${endDate}`,
  getAverageConversationLength: (startDate, endDate) =>
    `/Dashboard2/GetAverageConversationLength/${startDate}/${endDate}`,
  getTopWorkflows: (startDate, endDate) =>
    `/Dashboard2/GetTopWorkflows/${startDate}/${endDate}`,
  getKnowledgeBase: (startDate, endDate) =>
    `/Dashboard2/GetKnowledgebase/${startDate}/${endDate}`,
  getMesssagesByTopicCountries: (startDate, endDate) =>
    `/Dashboard2/GetCountries/${startDate}/${endDate}`,
  getQuestionsByCategory: (startDate, endDate) =>
    `/Dashboard2/GetQuestionsByCategory/${startDate}/${endDate}`,
  getQuesByTopic: (startDate, endDate) =>
    `/Dashboard2/getQuestionsByTopic/${startDate}/${endDate}`,
  getQuestionsByWorkflow: (startDate, endDate) =>
    `/Dashboard2/GetQuestionsByWorkflow/${startDate}/${endDate}`,
  getResolutionRate: (startDate, endDate) =>
    `/Dashboard2/GetResolutionRate/${startDate}/${endDate}`,
};

// Azure
export const azureEndpoints = {
  getActiveIndexers: () => '/Azure/GetActiveIndexers',
  getContainers: () => '/Azure/GetContainers',
  getMaterialsByContainer: (containerId, pageNumber, pageSize) =>
    `/Azure/GetMaterialByContainer/${containerId}/${pageNumber}/${pageSize}`,
  getContainerById: (containerId) => `/Azure/GetContainerById/${containerId}`,
  createSearchIndexer: (containerId, index) =>
    `/Azure/CreateSearchIndexer/${containerId}?scheduleOption=${index}`,
  deleteMaterial: (containerMaterialId) =>
    `/Azure/DeleteBlobFromContainer/${containerMaterialId}`,
  deleteTopic: (topicId) => `/Azure/DeleteContainer/${topicId}`,
  createTopic: (topicName) => `/Azure/CreateContainer/${topicName}`,
  editPrompt: () => '/Azure/ContainerPrompt',
  uploadBlobToContainer: () => '/Azure/UploadBlobToContainer',
  refreshIndexers: (containerId) =>
    `/Azure/RefeshSearchIndexers/${containerId}`,
  azureLanguages: '/Azure/GetLanguages',
  azureGender: '/Azure/GetGenders',
  azurePersonalityTypes: '/Azure/GetPersonalityTypes',
};

// Categories
export const categoriesEndpoints = {
  getAllCategories: `/api/Category/GetCategories`,
  getParentCategories: `/api/Category/GetParentCategories`,
  getChatCategorization: `/api/Category/GetChatCategorization`,
  categorizeChat: (categoryId, chatId) =>
    `/api/Category/CategorizeChat/${categoryId}/${chatId}`,
  createCategory: (categoryName, botId) => `/api/Category/SaveCategory`,
  deleteCategory: (categoryId) => `/api/Category/DeleteCategory/${categoryId}`,
};

// keywords
export const keywordsEndpoints = {
  create: `/api/KeyWord/AddBlockedKeyword`,
  update: `/api/KeyWord/UpdateBlockedKeyword`,
  delete: (id) => `/api/KeyWord/DeleteBlockedKeyword/${id}`,
  get: `/api/KeyWord/GetAllBlockedKeywords`,
  getById: `/api/KeyWord/GetAllBlockedKeywordById`,
};

// Chat
export const chatEndpoints = {
  getFavoriteChats: () => '/Chat/GetAllFavorites',
  getIndividualChats: (searchText) =>
    `/Chat/GetAllIndividualChats${
      searchText ? `?SearchField=${searchText}` : ''
    }`,
  getGroupChats: (searchText) =>
    `/Chat/GetAllGroupChats${searchText ? `?SearchField=${searchText}` : ''}`,
  getChatById: (chatId) => `/Chat/GetChatDetailsById/${chatId}`,
  getInstituteChats: (containerId, searchText) =>
    `/Chat/GetAllIndividualInstituteChats/${containerId}${
      searchText ? `?SearchField=${searchText}` : ''
    }`,
  getGroupInstituteChats: (containerId, searchText) =>
    `/Chat/GetAllGroupInstituteChats/${containerId}${
      searchText ? `?SearchField=${searchText}` : ''
    }`,
  rateResponse: (chatDetailId, rating) =>
    `/Chat/RateChatResponse/${chatDetailId}/${rating}`,
  editTitle: (chatId, title) => `/Chat/EditChatTitleById`,
  setMessage: (chatId, activeProjectId, text) =>
    `/Azure/ChatWithData/${chatId}/${activeProjectId}/${text}`,
  addFavorite: (chatId, isFavorite) =>
    `/Chat/SetChatAsFavorite/${chatId}/${!isFavorite}`,
  deleteChat: (chatId) => `/Chat/DeleteChat/${chatId}`,
  removeDocument: (chatId) => `/Azure/RemoveDocumentByChatId/${chatId}`,
  setAdmin: (chatId, userId) => `/Chat/SaveTemporaryAdmin/${chatId}/${userId}`,
};

// Company
export const companyEndpoints = {
  getCompanyDescription: () => '/Company/GetCompanyDescription',
  getChatSettings: '/Company/GetChatSettings',
  setCompanyChatSettings: () => '/Company/SaveChatSettings',
  editCompanyInfo: () => '/Company/EditCompanyInfo',
};

// Groups
export const groupEndpoints = {
  getGroupById: (groupId) => `/Group/GetGroupsById/${groupId}`,
  getGroupImage: (groupId) => `/Group/GetGroupImage/${groupId}`,
  getCompanyGroups: () => `/Group/GetGroups`,
  getUserNotInGroup: (groupId) => `/Group/GetUsersNotInGroup/${groupId}`,
  exportGroups: () => '/Group/ExportGroups',
  exportUsersInGroup: (groupId) => `/Group/ExportUsersInGroup/${groupId}`,
  addTag: () => `/Group/AddTagToGroup`,
  bulkAddUsers: () => '/Group/AddUserToGroupBulk',
  deleteGroup: (groupId) => `/Group/DeleteGroup?groupId=${groupId}`,
  uploadImage: () => '/Group/UploadGroupImage',
  deleteTag: () => `/Group/RemoveTagFromGroup`,
  removeUser: () => `/Group/RemoveUserFromGroup`,
  bulkUploadGroups: () => '/Group/UploadGroups',
  bulkUploadGroupUsers: () => '/Group/UploadGroupUsers',
  editGroupName: () => `/Group/EditGroupName`,
  createGroup: () => `/Group/CreateGroup`,
  getUserGroups: () => `/api/UserGroup/GetUserGroups`,
  createUserGroup: () => `/api/UserGroup/CreateUserGroup`,
};

// Role
export const roleEndpoints = {
  getRoles: () => '/Role/GetRoles',
  getRoutes: () => '/Role/GetRoutes',
  updateUserRole: () => '/Role/UpdateUserRole',
};

// Script
export const scriptEndpoints = {
  getCompanyBots: '/api/BotScript/GetCompanyBots',
  getBotSettings: (botId) => `/api/BotScript/GetBotChatSettings/${botId}`,
  createBot: () => '/api/BotScript/CreateBot',
  editBot: () => '/api/BotScript/Edit_Bot',
  deleteBot: (id) => `/api/BotScript/DeleteBot?BotId=${id}`,
  disableBot: (id, status) => `/api/BotScript/DisableBot/${id}/${status}`,
  voiceGallery: '/api/BotScript/GetVoiceGallery',
  getRestrictedUrl: (id) => `/api/BotScript/URLRestriction?BotId=${id}`,
  updateRestrictedUrl: () => `/api/BotScript/AddURLRestriction`,
  getBotScript: (id) => `/api/botScript/GetBotScript?BotId=${id}`,
  getBots: () => '/api/BotScript/GetBots',
};

// User
export const userEndpoints = {
  getAuthUser: () => '/User/GetAuthenticatedUser',
  getCompanyUsers: `/User/GetAllUsers`,
  getUserImage: (userId) => `/User/GetUserImage/${userId}`,
  getUserById: (userId) => `/User/GetUserByUserId?userId=${userId}`,
  getActivitiesById: `/User/GetActivityByUserId`,
  getUsageById: (userId, from, to) =>
    `/User/GetUsageByUserId?userId=${userId}&from=${from}&to=${to}`,

  exportUsersTable: () => '/User/ExportUsers',
  deleteUser: (userId) => `/User/DeleteUser?userId=${userId}`,
  bulkDeleteUsers: () => '/User/BulkDeleteUser',
  editUser: (userId) => `/User/EditUser/${userId}`,
  uploadProfilePicture: () => '/User/UploadUserImage',
  changePassword: (userId, password) =>
    `/User/ResetPassword?userId=${userId}&newPassword=${password}`,
  createUser: () => '/User/CreateUser',
  bulkUploadUsers: () => '/User/UploadUsers',
  lockUser: (id, status) => `/User/LockUser/${id}/${status}`,
  contactSupport: () => '/User/CreateUserSupportTicket',
};

// Settings
export const settingsEndpoints = {
  getBranding: () => '/Branding/GetBranding',
  // getBotBranding: (botId) => `/Branding/GetBotBranding/${botId}`,
  getBotBranding: () => `/api/BotScript/GetBotUI`,
  getBotById: (id) => `/api/BotScript/GetBotById?BotId=${id}`,
  getChatSettings: () => '/Company/GetChatSettings',
  // setBotBranding: () => '/Branding/SetBotBranding',
  setBotBranding: () => '/api/BotScript/BotUI',
  setBotChatSettings: () => '/api/BotScript/SaveBotChatSettings',
  setCompanyBranding: () => '/Branding/SetCompanyBranding',
  getResponseTheme: () => '/api/BotScript/GetResponseThemes',
  getCustomResponseThemes: () => '/api/BotScript/GetAllBotCustomResponseThemes',
  postResponseTheme: () => '/api/BotScript/PostCustomResponseTheme',
};

export const sidebar = {
  get: '/Role/GetRoutes',
};

export const knowledgeBase = {
  getKnowledgeBase: '/Folder/GetKnowledgeBase',
  getKnowledgeBaseId: `/Folder/GetMaterialByFolder`,
  delete: (id) => `/Folder/DeleteFoler/${id}`,
  newFolder: (folderName) => `/Folder/CreateFolder${folderName}`,
  getMaterial: (id) => `/Azure/GenerateMaterialSASURL/${id}`,
  refreshIndexers: '/Azure/RefreshSearchIndexer',
  getFolder: '/Folder/GetFolders',
  getFoldersByBotId: (botId) => `/Folder/GetFoldersByBotId/${botId}`,
  UploadBlobToContainer: '/Azure/UploadBlobToContainer',
  deleteFile: (id) => `/Azure/DeleteBlobFromContainer/${id}`,
};
export const variableManagement = {
  get: '/api/Variables/GetAllVariables',
  delete: (id) => `/api/Variables/DeleteVariable/${id}`,
  create: () => `/api/Variables/AddVariable`,
  update: () => `/api/Variables/UpdateVariable`,
};

export const Themes = {
  getThemes: '/api/BotScript/GetResponseThemes',
  getCustomThemes: '/api/BotScript/GetCustomResponseThemes',
};

//workflow
export const workflow = {
  getAllWorkflowsPaged: '/GetAllWorkflowsPaged',
  getWorkflowById: (id) => `/GetWorkflowById?Id=${id}`,
  getVariableTypes: '/api/Variables/GetVariableTypes',
  createWorkflow: '/CreateUpdateWorkflow',
  update: '/UpdateWorkflow',
  delete: (id) => `/DeleteWorkflow?Id=${id}`,
  createEvent: '/CreateEvent',
  updateEvent: '/UpdateEvent',
  createIntent: '/CreateIntent',
  updateIntent: '/UpdateIntent',
  getEventByWorkflowId: (id) => `/GetEventByWorkFlowId?WorkFlowId=${id}`,
  getIntentByWorkflowId: (id) => `/GetIntentByWorkFlowId?Id=${id}`,
  getFormsByWorkflowId: (id) => `/Forms/GetFormsByWorkflowId?WorkflowId=${id}`,
  getFormById: (id) => `/Forms/GetForm?formId=${id}`,
  getThemesByWorkFlowId: (id) => `/GetThemesByWorkFlow?WorkflowId=${id}`,
  disableWorkflow: (id, status) =>
    `/WorkflowActivateDeactivate/${id}/${status}`,
  autoGenerateMessageVariants: '/GenerateMessageVariants',
  setPriority: (id, priority, botId) =>
    `/UpdateWorkflowPriority/${id}?BotId=${botId}&priority=${priority}`,
};

// Forms
export const formsEndpoints = {
  getForms: '/Forms/GetFormsPaged',
  getFormTypes: '/Forms/GetFormInputTypes',
  createForm: '/Forms/CreateForm',
  getForm: '/Forms/GetForm',
  deleteForm: (id) => `/Forms/DeleteForm/${id}`,
  toggleForm: (id, status) => `/Forms/ActivateForm/${id}/${status}`,
  getFormsByBotId: '/Forms/GetFormsByBotId',
  getFormResponseByFormId: '/Forms/getFormResponseByFormId',
  formResponse: (id) => `/Forms/ExportFormEntriesFromBot/${id}`,
  getFormResponsesAsCategories: '/Forms/GetFormResponsesAsCategories',
  getChatProfile: () => '/Forms/GetChatProfile',
};

// Topics
export const topics = {
  getTopics: '/api/Topic/GetTopics',
  saveTopic: '/api/Topic/SaveTopic',
  deleteTopic: (id) => `/api/Topic/DeleteTopic/${id}`,
};

export const chat = {
  postResponse: '/api/ChatBot/GuestChatNew',
  postGuestChat: '/api/ChatBot/GuestChat',

  // getChats: `/api/ChatBot/GetChats?BotId=be6ebf39-491a-4691-8442-8fdb6d418c48`,
  postForm: '/api/ChatBot/SubmitForm',
  postLike: '/',
  getChats: (id) => `/api/ChatBot/GetChats?BotId=${id}&ChatSource=${2}`,
  getChatsId: `/api/ChatBot/GetChats`,
  getConversations: `/api/ChatBot/getConversations`,
  getChatById: (id) => `/api/ChatBot/GetChatByChatId?ChatId=${id}`,
  getVoice: (ChatDetailId, BotId) =>
    `/api/ChatBot/TextToSpeech/${ChatDetailId}/${BotId}`,
  rateChatResponse: '/api/ChatBot/RateChatResponse',
};

export const AICall = {
  speechToText: '/api/ChatBot/SpeechToText',
};
export const Agent = {
  newConnection: '/api/Agent/NewConnection',
  editConnection: '/api/Agent/EditConnection',
  getAgentAPISelection: (id) => `/api/Agent/GetAgentAPISelection/${id}`,
  getAgentsTypes: '/api/Agent/GetAgentTypes',
  SaveConnectionDetails: '/api/Agent/SaveConnectionDetails',
  SyncAll: '/api/AgentData/SyncAll',
  SyncConnection: `/api/AgentData/SyncConnection`,
  SaveInnerConnectionDetails: '/api/Agent/SaveInnerConnectionDetails',
  getAllAgents: (id) => `/api/Agent/GetAgents/${id}`,
  testConnection: (id) => `/api/AgentData/TestConnection/${id}`,
  forceSync: (id) => `/api/Agent/ForceSync/${id}`,
  getApiLogs: (id) => `/api/agent/getAgentApiLogs/${id}`,
  disconnectAgent: (id) => `/api/agent/disconnectAgent/${id}`,
  connectAgent: (id) => `/api/agent/connectAgent/${id}`,
  getConnectionByBotId: (id, agentType) =>
    `/api/Agent/GetConnectionsByBotId/${id}/${agentType}`,
  getApis: (agentId) => `/api/agent/getAPIS/${agentId}`,
  deleteAgent: (id) => `/api/agent/deleteAgent/${id}`,
  deleteAgentApi: (id) => `/api/AgentData/DeleteAgent/${id}`,
  GetTaskStatus: (id) => `/api/AgentData/GetTaskStatus/${id}`,
  getAgentAPISelection: (id) => `/api/Agent/GetAgentAPISelection/${id}`,
  getTableData: (id) => `/api/AgentData/TableData/${id}`,
  exportTableDataToCSV: (id) => `/api/AgentData/ExportToCSV/${id}`,
  getTerms: (agentConnectionDetailId) =>
    `/api/AgentData/Terms/${agentConnectionDetailId}`,
  saveTerms: (agentConnectionDetailId) =>
    `/api/agentData/saveTerms/${agentConnectionDetailId}`,
  getRecentActivities: '/Dashboard2/GetRecentActivities',
};

export const documentation = {
  getDocs: '/api/Documentation/GetDocumentation',
};

// Prompt Settings
export const promptSettings = {
  createPromptSettings: '/api/botPromptSettings/createOrUpdate',
  getBotById: '/api/botPromptSettings/getByBotId',
  getDefault: '/api/botPromptSettings/getDefaultPromptSettings',
};
